import { getConfig } from '../config';

import RestClient from './RestClient';

const { fullUrl } = getConfig();

export interface CountUnseenNotificationsResponse {
  count: number;
}

class NotificationsClient extends RestClient {
  constructor() {
    super({
      baseUrl: `${fullUrl}/gateway/api/notification-log/api/2/notifications`,
    });
  }

  countUnseenNotifications(): Promise<CountUnseenNotificationsResponse> {
    return this.getResource('/count/unseen');
  }
}

export default new NotificationsClient();
